class EsmeraldaMobileProduct {
  constructor(root) {
    this.root = root;
    this.quantity = root.querySelector('[data-mobile-quantity] input');
    this.variant = root.querySelector('[data-mobile-variant]');
    this.addButton = root.querySelector('[data-mobile-add]');
    this.price = root.querySelector('[data-mobile-current-price]');
    this.comparePrice = root.querySelector('[data-mobile-compare-price]');
    this.discount = root.querySelector('[data-mobile-off]');
    this.stock = root.querySelector('[data-mobile-stock]');
    this.image = root.querySelector('.es-product-mobile__image');
    this.optionInputs = Array.from(root.querySelectorAll('[data-mobile-option]'));

    root.querySelector('[data-mobile-quantity-decrease]')?.addEventListener('click', () => this.changeQuantity(-1));
    root.querySelector('[data-mobile-quantity-increase]')?.addEventListener('click', () => this.changeQuantity(1));
    this.variant?.addEventListener('change', () => this.updateVariant());
    for (const input of this.optionInputs) {
      input.addEventListener('change', () => this.selectVariantFromOptions());
    }

    const previewUrls = new Set(
      Array.from(this.variant?.options || [])
        .map((option) => option.dataset.imageUrl)
        .filter(Boolean)
    );
    for (const sourceUrl of previewUrls) {
      const preload = new Image();
      preload.decoding = 'async';
      preload.fetchPriority = 'low';
      preload.src = sourceUrl;
    }
  }

  changeQuantity(change) {
    const current = Number.parseInt(this.quantity.value, 10) || 1;
    this.quantity.value = Math.max(1, current + change);
    this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }

  selectVariantFromOptions() {
    const currentOption = this.variant?.selectedOptions[0];
    if (!currentOption) return;

    const selectedValues = JSON.parse(currentOption.dataset.options || '[]');
    for (const group of this.root.querySelectorAll('[data-mobile-option-group]')) {
      const checkedInput = group.querySelector('[data-mobile-option]:checked');
      if (!checkedInput) continue;

      selectedValues[Number(checkedInput.dataset.optionPosition) - 1] = checkedInput.value;
      const selectedLabel = group.querySelector('[data-mobile-selected-option]');
      if (selectedLabel) selectedLabel.textContent = checkedInput.value;
    }

    const selectedOption = Array.from(this.variant.options).find((option) => {
      const optionValues = JSON.parse(option.dataset.options || '[]');
      return optionValues.length === selectedValues.length && optionValues.every((value, index) => value === selectedValues[index]);
    });
    if (!selectedOption) return;

    this.variant.value = selectedOption.value;
    this.variant.dispatchEvent(new Event('change', { bubbles: true }));

    const url = new URL(window.location.href);
    url.searchParams.set('variant', selectedOption.value);
    window.history.replaceState({}, '', url);
  }

  updateVariant() {
    const option = this.variant.selectedOptions[0];
    const available = option.dataset.available === 'true';
    this.price.textContent = option.dataset.price;
    if (option.dataset.comparePrice) {
      if (!this.comparePrice) {
        this.comparePrice = document.createElement('s');
        this.comparePrice.dataset.mobileComparePrice = '';
        this.price.after(this.comparePrice);
      }
      this.comparePrice.textContent = option.dataset.comparePrice;
      this.comparePrice.hidden = false;
    } else if (this.comparePrice) {
      this.comparePrice.hidden = true;
    }
    const priceCents = Number(option.dataset.priceCents);
    const comparePriceCents = Number(option.dataset.comparePriceCents);
    const discountPercentage = comparePriceCents > priceCents && comparePriceCents > 0
      ? Math.round(((comparePriceCents - priceCents) / comparePriceCents) * 100)
      : 0;
    if (discountPercentage > 0) {
      if (!this.discount) {
        this.discount = document.createElement('span');
        this.discount.className = 'es-product-mobile__off';
        this.discount.dataset.mobileOff = '';
        this.price.parentElement?.append(this.discount);
      }
      this.discount.textContent = `${discountPercentage}% off`;
      this.discount.hidden = false;
    } else if (this.discount) {
      this.discount.hidden = true;
    }
    this.addButton.disabled = !available;
    this.addButton.textContent = available ? 'Add to cart' : 'Sold out';
    this.stock.innerHTML = available ? '<span aria-hidden="true"></span> In stock' : 'Sold out';

    if (option.dataset.imageId) {
      const gallery = this.root.closest('.shopify-section')?.querySelector('media-gallery');
      gallery?.slideshow?.select({ id: option.dataset.imageId }, undefined, { animate: false });
    }

    if (this.image && option.dataset.imageUrl) {
      const selectedVariantId = option.value;
      this.image.src = option.dataset.imageUrl;
      this.image.removeAttribute('srcset');
      this.image.alt = option.dataset.imageAlt || this.image.alt;

      if (option.dataset.imageLargeUrl) {
        const fullSizeImage = new Image();
        fullSizeImage.decoding = 'async';
        fullSizeImage.onload = () => {
          if (this.variant.value === selectedVariantId) {
            this.image.src = fullSizeImage.src;
          }
        };
        fullSizeImage.src = option.dataset.imageLargeUrl;
      }
    }
  }
}

document.querySelectorAll('.es-product-mobile').forEach((root) => new EsmeraldaMobileProduct(root));
